import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'getSleepStatus'
})
export class GetSleepStatusPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    let status = 'Nunca';
    if (value === null) return status;
    switch (value) {
      case 1:
        status = 'Nunca';
        break;
      case 2:
        status = 'Raramente';
        break;
      case 3:
        status = 'A veces';
        break;
      case 4:
        status = 'Frecuente';
        break;
      case 5:
        status = 'Siempre';
        break;
    }
    return status;
  }

}
